// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1tCZA","list":"PatternAutocomplete_list__DLw3n"};